import { EmptyState, FlexColumn, FlexRow, Loading, useLoading } from '@gorila-shared-ui/components';
import { LabelMedium } from 'baseui/typography';
import { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil';
import { useStyles } from '../../hooks/useStyles';
import useUpdateEffect from '../../hooks/useUpdateEffect';
import { getEvents } from '../../services/gptService';
import { eventReloadState, eventSearchState, eventsState } from '../../storage/gptStates';
import GptEventCard from '../gpt/GptEventCard';
import GptEventFilters from '../gpt/GptEventFilters';
import { FloatingCardContent } from '../layout/cards/FloatingCardContent';
import { FloatingCardsLayout } from '../layout/FloatingCardsLayout';

export function ControlTowerPage() {
  const { theme, css } = useStyles();
  const [safeGptEvents, setSafeGptEvents] = useRecoilState(eventsState);
  const [page, setPage] = useState(0);
  const { loading, startLoading, stopLoading } = useLoading();
  const [reloadPage, setReloadPage] = useRecoilState(eventReloadState);
  const search = useRecoilValue(eventSearchState);
  const resetSearch = useResetRecoilState(eventSearchState);
  const totalEvents = safeGptEvents?.total ?? 0;

  useEffect(() => {
    return () => {
      resetSearch();
    };
  }, []);

  useUpdateEffect(() => {
    if (reloadPage === 'update') {
      setPage(0);
      setReloadPage(undefined);
    }
  }, [reloadPage]);

  useUpdateEffect(() => {
    setPage(0);
  }, [search]);

  useEffect(() => {
    if (page === 0) {
      setPage(1);
      return;
    }
    const loadEvents = async () => {
      startLoading();
      const { paginatedResponse, error } = await getEvents(page, search);
      if (!error && paginatedResponse) {
        setSafeGptEvents(paginatedResponse);
      } else {
        setSafeGptEvents(undefined);
      }
      stopLoading();
    };
    loadEvents();
  }, [page]);

  return (
    <FloatingCardsLayout
      contentSize="medium"
      content={
        <FloatingCardContent
          flexible
          gap={theme.sizing.scale600}
        >
          {!safeGptEvents && !loading && <EmptyState title="Todavía no cuentas con eventos" />}
          {!safeGptEvents && loading && <Loading />}
          {safeGptEvents && (
            <>
              <GptEventFilters />
              {!!safeGptEvents.items.length && (
                <>
                  <div
                    id="scrollableDiv"
                    className={css({ flex: 1, overflow: 'auto' })}
                  >
                    <InfiniteScroll
                      dataLength={safeGptEvents.items.length ?? 0} //This is important field to render the next data
                      next={() => setPage(page + 1)}
                      hasMore={safeGptEvents.hasNext ?? false}
                      loader={<></>}
                      scrollableTarget="scrollableDiv"
                    >
                      <FlexColumn gap={'8px'}>
                        {safeGptEvents.items.map((event, i) => (
                          <GptEventCard
                            event={event}
                            key={i}
                          />
                        ))}
                      </FlexColumn>
                    </InfiniteScroll>
                  </div>
                  <FlexRow
                    centered
                    classNames={css({
                      background: theme.colors.backgroundSecondary,
                      padding: `6px ${theme.sizing.scale300}`,
                      borderRadius: theme.sizing.scale300,
                    })}
                  >
                    <LabelMedium>
                      {totalEvents} {totalEvents === 1 ? 'caso activo' : 'casos activos'}
                    </LabelMedium>
                  </FlexRow>
                </>
              )}
              {!safeGptEvents.items.length && (
                <EmptyState
                  title="No se encontraron resultados"
                  description="Intenta con otra busqueda"
                />
              )}
            </>
          )}
        </FloatingCardContent>
      }
    />
  );
}
